import { put, call, takeLatest } from "redux-saga/effects";
import {
  GETAGENTSFAILURE,
  GETAGENTSNAMESFAILURE,
  GETAGENTSNAMESREQUEST,
  GETAGENTSNAMESSUCCESS,
  GETAGENTSREQUEST,
  GETAGENTSSUCCESS,
  GETDISTRIBUTORFAILURE,
  GETDISTRIBUTORNAMESFAILURE,
  GETDISTRIBUTORNAMESREQUEST,
  GETDISTRIBUTORNAMESSUCCESS,
  GETDISTRIBUTORREQUEST,
  GETDISTRIBUTORSUCCESS,
  GETFASTAGFAILURE,
  GETFASTAGREQUEST,
  GETFASTAGSUCCESS,
  GETINVENTORYAGENTFAILURE,
  GETINVENTORYAGENTREQUEST,
  GETINVENTORYAGENTSUCCESS,
  GETINVENTORYDISTRIBUTORFAILURE,
  GETINVENTORYDISTRIBUTORREQUEST,
  GETINVENTORYDISTRIBUTORSUCCESS,
  GETINVENTORYFAILURE,
  GETINVENTORYREQUEST,
  GETINVENTORYSUCCESS,
  GETREPORTFAILURE,
  GETREPORTREQUEST,
  GETREPORTSUCCESS,
  GETSTATEFAILURE,
  GETSTATEREQUEST,
  GETSTATESUCCESS,
  GETCITYFAILURE,
  GETCITYREQUEST,
  GETCITYSUCCESS,
  LOGINFAILURE,
  LOGINREQUEST,
  LOGINSUCCESS,
  SENDOTPFAILURE,
  SENDOTPREQUEST,
  SENDOTPSUCCESS,
  CHANGEPASSWORDREQUEST,
  CHANGEPASSWORDSUCCESS,
  CHANGEPASSWORDFAILURE,
  EDITDISTRIBUTORREQUEST,
  EDITDISTRIBUTORSUCCESS,
  EDITDISTRIBUTORFAILURE,
  GETMASTERFASTAGREQUEST,
  GETMASTERFASTAGSUCCESS,
  GETMASTERFASTAGFAILURE,
  GETALLAGENTSNAMESREQUEST,
  GETALLAGENTSNAMESSUCCESS,
  GETALLAGENTSNAMESFAILURE,
  GETINVENTORYSUMMARYREQUEST,
  GETINVENTORYSUMMARYSUCCESS,
  GETINVENTORYSUMMARYFAILURE,
  CREATEDISTRIBUTORBULKREQUEST,
  CREATEDISTRIBUTORBULKSUCCESS,
  CREATEDISTRIBUTORBULKFAILURE,
  CREATEAGENTBULKREQUEST,
  CREATEAGENTBULKSUCCESS,
  CREATEAGENTBULKFAILURE,
  GETDISTRIBUTORSUMMARYREQUEST,
  GETDISTRIBUTORSUMMARYSUCCESS,
  GETDISTRIBUTORSUMMARYFAILURE,
  GETDISTRIBUTORAGENTSUMMARYREQUEST,
  GETDISTRIBUTORAGENTSUMMARYSUCCESS,
  GETDISTRIBUTORAGENTSUMMARYFAILURE,
  GETAGENTSUMMARYREQUEST,
  GETAGENTSUMMARYSUCCESS,
  GETAGENTSUMMARYFAILURE,
  GETDISTRIBUTORREQUESTREQUEST,
  GETDISTRIBUTORREQUESTSUCCESS,
  GETDISTRIBUTORREQUESTFAILURE,
  ASSIGNAGENTEXCELREQUEST,
  ASSIGNAGENTEXCELSUCCESS,
  ASSIGNAGENTEXCELFAILURE,
  GETALLFASTAGAGENTREQUESTREQUEST,
  GETALLFASTAGAGENTREQUESTSUCCESS,
  GETALLFASTAGAGENTREQUESTFAILURE,
  GETAGENTFASTAGREQUEST,
  GETAGENTFASTAGSUCCESS,
  GETAGENTFASTAGFAILURE,
  UPDATEAGENTREQUESTSTATUSREQUEST,
  UPDATEAGENTREQUESTSTATUSSUCCESS,
  UPDATEAGENTREQUESTSTATUSFAILURE,
  DENIEDREQUESTSTATUSREQUEST,
  DENIEDREQUESTSTATUSSUCCESS,
  DENIEDREQUESTSTATUSFAILURE,
  ASSIGNDISTRIBUTOREXCELREQUEST,
  ASSIGNDISTRIBUTOREXCELSUCCESS,
  ASSIGNDISTRIBUTOREXCELFAILURE,
  GET_AGENTS_DISTRIBUTOR_WISE_REQUEST,
  GET_AGENTS_DISTRIBUTOR_WISE_SUCCESS,
  GET_AGENTS_DISTRIBUTOR_WISE_FAILURE,
  REFRESH_DATA,
} from "./actionTypes";
import { API } from "../Common/Api";
import { ErrorToast } from '../Common/Toast';



export function* GetLoginAsync({ params }) {
  try {
    const response = yield call(API.Login, params);
    yield put({
      type: LOGINSUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: LOGINFAILURE, payload: e });
  }
}

export function* GetInventoryAsync({ params }) {
  try {
    const response = yield call(API.GetInventory, params);
    yield put({
      type: GETINVENTORYSUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: GETINVENTORYFAILURE, payload: e });
  }
}

export function* GetReportAsync({ params }) {
  try {
    const response = yield call(API.GetReport, params);
    yield put({
      type: GETREPORTSUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: GETREPORTFAILURE, payload: e });
  }
}

export function* GetFastagAsync({ params }) {
  try {
    const response = yield call(API.GetFastag, params);
    yield put({
      type: GETFASTAGSUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: GETFASTAGFAILURE, payload: e });
  }
}

export function* GetAgentsAsync({ params }) {
  try {
    const response = yield call(API.GetAgents, params);
    yield put({
      type: GETAGENTSSUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: GETAGENTSFAILURE, payload: e });
  }
}

export function* GetAgentsNamesAsync({ params }) {
  try {
    const response = yield call(API.GetAgentsNames, params);
    yield put({
      type: GETAGENTSNAMESSUCCESS,
      payload: response,
    });
  } catch (e) {
    console.error('❌ GetAgentsNames Saga - Error:', e);
    yield put({ type: GETAGENTSNAMESFAILURE, payload: e });
  }
}

export function* GetInventoryDistributorAsync({ params }) {
  try {
    const response = yield call(API.GetInventoryDistributor, params);
    yield put({
      type: GETINVENTORYDISTRIBUTORSUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: GETINVENTORYDISTRIBUTORFAILURE, payload: e });
  }
}

export function* GetDistributorAsync({ params }) {
  try {
    const response = yield call(API.GetDistributor, params);
    yield put({
      type: GETDISTRIBUTORSUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: GETDISTRIBUTORFAILURE, payload: e });
  }
}

export function* GetDistributorNamesAsync({ params }) {
  try {
    const response = yield call(API.GetDistributorNames, params);
    yield put({
      type: GETDISTRIBUTORNAMESSUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: GETDISTRIBUTORNAMESFAILURE, payload: e });
  }
}

export function* GetInventoryAgentAsync({ params }) {
  try {
    const response = yield call(API.GetInventoryAgent, params);
    yield put({
      type: GETINVENTORYAGENTSUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: GETINVENTORYAGENTFAILURE, payload: e });
  }
}

export function* GetStateAsync({ params }) {
  try {
    const response = yield call(API.GetState, params);
    yield put({
      type: GETSTATESUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: GETSTATEFAILURE, payload: e });
  }
}

export function* GetCityAsync({ params }) {
  try {
    const response = yield call(API.GetCity, params);
    yield put({
      type: GETCITYSUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: GETCITYFAILURE, payload: e });
  }
}

export function* SendOtpAsync({ params }) {
  try {
    const response = yield call(API.SendOtp, params);
    yield put({
      type: SENDOTPSUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: SENDOTPFAILURE, payload: e });
  }
}

export function* ChangePasswordAsync({ params }) {
  try {
    const response = yield call(API.ChangePassword, params);
    yield put({
      type: CHANGEPASSWORDSUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: CHANGEPASSWORDFAILURE, payload: e });
  }
}

export function* EditDistributorAsync({ distributorId, params }) {
  try {
    const response = yield call(API.EditDistributor, distributorId, params);
    yield put({
      type: EDITDISTRIBUTORSUCCESS,
      payload: response,
    });
    yield put({ type: REFRESH_DATA });
  } catch (e) {

    yield put({ type: EDITDISTRIBUTORFAILURE, payload: e });
  }
}

export function* GetMasterFastagAsync({ params }) {
  try {
    const response = yield call(API.GetMasterFastag, params);
    yield put({
      type: GETMASTERFASTAGSUCCESS,
      payload: response,
    });
  } catch (e) {

    yield put({ type: GETMASTERFASTAGFAILURE, payload: e });
  }
}

export function* GetAllAgentsNamesAsync({ params }) {
  try {
    const response = yield call(API.GetAllAgentsNames, params);
    yield put({
      type: GETALLAGENTSNAMESSUCCESS,
      payload: response,
    });
  } catch (e) {
    console.error('❌ GetAllAgentsNames Saga - Error:', e);
    yield put({ type: GETALLAGENTSNAMESFAILURE, payload: e });
  }
}

export function* GetInventorySummaryAsync() {
  try {
    const response = yield call(API.GetInventorySummary);
    yield put({
      type: GETINVENTORYSUMMARYSUCCESS,
      payload: response,
    });
  } catch (e) {
    console.error('❌ GetInventorySummary Saga - Error:', e);
    yield put({ type: GETINVENTORYSUMMARYFAILURE, payload: e });
  }
}

export function* CreateDistributorBulkAsync({ params }) {
  try {
    const response = yield call(API.CreateDistributorBulk, params);

    // Check if the response has a valid status (2xx means success)
    if (response && response.status && response.status >= 200 && response.status < 300) {
      yield put({
        type: CREATEDISTRIBUTORBULKSUCCESS,
        payload: response,
      });
      yield put({ type: REFRESH_DATA });
    } else {
      // Handle API errors (4xx, 5xx status codes)
      console.error('❌ CreateDistributorBulk Saga - API Error Status:', response?.status);
      if (response?.status === 409 && response?.data) {
        ErrorToast(response.data.message || 'Duplicate entries found.');
        // Additional logic to display detailed info can be added here
      } else {
        ErrorToast(response?.data?.message || 'Unknown error occurred');
      }
      yield put({
        type: CREATEDISTRIBUTORBULKFAILURE,
        payload: response || { message: 'Unknown error occurred' }
      });
      console.error('❌ CreateDistributorBulk Saga - Failure action dispatched due to status code');
    }
  } catch (e) {
    ErrorToast('Connection failed');
    console.error('❌ CreateDistributorBulk Saga - Network/Exception Error:', e);
    yield put({ type: CREATEDISTRIBUTORBULKFAILURE, payload: e });
    console.error('❌ CreateDistributorBulk Saga - Failure action dispatched due to exception');
  }
}

export function* CreateAgentBulkAsync({ params }) {
  try {
    const response = yield call(API.CreateAgentBulk, params);


    // Check if the response has a valid status (2xx means success)
    if (response && response.status && response.status >= 200 && response.status < 300) {
      yield put({
        type: CREATEAGENTBULKSUCCESS,
        payload: response,
      });
      yield put({ type: REFRESH_DATA });

    } else {
      // Handle API errors (4xx, 5xx status codes)
      if (response?.status === 409 && response?.data) {
        ErrorToast(response.data.message || 'Duplicate entries found.');
        // Additional logic to display detailed info can be added here
      } else {
        ErrorToast(response?.data?.message || 'Unknown error occurred');
      }
      yield put({
        type: CREATEAGENTBULKFAILURE,
        payload: response || { message: 'Unknown error occurred' }
      });
    }
  } catch (e) {
    ErrorToast('Connection failed');
    yield put({ type: CREATEAGENTBULKFAILURE, payload: e });
  }
}

export function* GetDistributorSummaryAsync() {
  try {
    const response = yield call(API.GetDistributorSummary);
    yield put({
      type: GETDISTRIBUTORSUMMARYSUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: GETDISTRIBUTORSUMMARYFAILURE, payload: e });
  }
}

export function* GetDistributorAgentSummaryAsync({ params }) {
  try {
    const response = yield call(API.GetDistributorAgentSummary, params);
    yield put({
      type: GETDISTRIBUTORAGENTSUMMARYSUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: GETDISTRIBUTORAGENTSUMMARYFAILURE, payload: e });
  }
}

export function* GetAgentSummaryAsync() {
  try {
    const response = yield call(API.GetAgentSummary);
    yield put({
      type: GETAGENTSUMMARYSUCCESS,
      payload: response,
    });
  } catch (e) {
    console.error('❌ GetAgentSummary Saga - Error:', e);
    yield put({ type: GETAGENTSUMMARYFAILURE, payload: e });
  }
}

export function* GetDistributorRequestAsync({ params }) {
  try {
    const response = yield call(API.GetDistributorRequest, params);

    yield put({
      type: GETDISTRIBUTORREQUESTSUCCESS,
      payload: response,
    });
  } catch (e) {
    ErrorToast('Failed to fetch distributor requests');
    yield put({ type: GETDISTRIBUTORREQUESTFAILURE, payload: e });
  }
}

export function* AssignAgentExcelAsync({ params }) {
  try {
    const response = yield call(API.AssignAgentExcel, params);

    // Check if the response has a valid status (2xx means success)
    if (response && response.status && response.status >= 200 && response.status < 300) {
      yield put({
        type: ASSIGNAGENTEXCELSUCCESS,
        payload: response,
      });
      yield put({ type: REFRESH_DATA });
    } else {
      // Handle API errors (4xx, 5xx status codes)
      console.error('❌ AssignAgentExcel Saga - API Error Status:', response?.status);
      if (response?.status === 400 && response?.message) {
        ErrorToast(response.message || 'Invalid file or data.');
      } else {
        ErrorToast(response?.message || 'Failed to assign agents via Excel.');
      }
      yield put({
        type: ASSIGNAGENTEXCELFAILURE,
        payload: response || { message: 'Unknown error occurred' }
      });
      console.error('❌ AssignAgentExcel Saga - Failure action dispatched due to status code');
    }
  } catch (e) {
    ErrorToast('Connection failed');
    console.error('❌ AssignAgentExcel Saga - Network/Exception Error:', e);
    yield put({ type: ASSIGNAGENTEXCELFAILURE, payload: e });
    console.error('❌ AssignAgentExcel Saga - Failure action dispatched due to exception');
  }
}

export function* GetAllFastagAgentRequestAsync({ params }) {
  try {
    const response = yield call(API.GetAllFastagAgentRequest, params);
    yield put({
      type: GETALLFASTAGAGENTREQUESTSUCCESS,
      payload: response,
    });
  } catch (e) {
    console.error('❌ GetAllFastagAgentRequest Saga - Error:', e);
    yield put({ type: GETALLFASTAGAGENTREQUESTFAILURE, payload: e });
  }
}

export function* GetAgentFastagAsync({ params }) {
  try {
    const response = yield call(API.GetAgentFastag, params);
    yield put({
      type: GETAGENTFASTAGSUCCESS,
      payload: response,
    });
  } catch (e) {
    console.error('❌ GetAgentFastag Saga - Error:', e);
    yield put({ type: GETAGENTFASTAGFAILURE, payload: e });
  }
}

export function* UpdateAgentRequestStatusAsync({ params }) {
  try {
    const response = yield call(API.UpdateAgentRequestStatus, params);
    yield put({
      type: UPDATEAGENTREQUESTSTATUSSUCCESS,
      payload: response,
    });
    yield put({ type: REFRESH_DATA });
  } catch (e) {
    console.error('❌ UpdateAgentRequestStatus Saga - Error:', e);
    yield put({ type: UPDATEAGENTREQUESTSTATUSFAILURE, payload: e });
  }
}

export function* DeniedRequestAsync({ params }) {
  try {
    const response = yield call(API.DeniedRequest, params);
    yield put({
      type: DENIEDREQUESTSTATUSSUCCESS,
      payload: response,
    });
    yield put({ type: REFRESH_DATA });
  } catch (e) {
    console.error('❌ DeniedRequest Saga - Error:', e);
    yield put({ type: DENIEDREQUESTSTATUSFAILURE, payload: e });
  }
}

export function* AssignDistributorExcelAsync({ params }) {
  try {

    const response = yield call(API.AssignDistributorExcel, params);

    // Check if the response has a valid status (2xx means success)
    if (response && response.status && response.status >= 200 && response.status < 300) {
      yield put({
        type: ASSIGNDISTRIBUTOREXCELSUCCESS,
        payload: response,
      });
      yield put({ type: REFRESH_DATA });
    } else {
      // Handle API errors (4xx, 5xx status codes)
      console.error('❌ AssignDistributorExcel Saga - API Error Status:', response?.status);
      if (response?.status === 400 && response?.message) {
        ErrorToast(response.message || 'Invalid file or data.');
      } else {
        ErrorToast(response?.message || 'Failed to assign distributor via Excel.');
      }
      yield put({
        type: ASSIGNDISTRIBUTOREXCELFAILURE,
        payload: response || { message: 'Unknown error occurred' }
      });
      console.error('❌ AssignDistributorExcel Saga - Failure action dispatched due to status code');
    }
  } catch (e) {
    ErrorToast('Connection failed');
    console.error('❌ AssignDistributorExcel Saga - Network/Exception Error:', e);
    yield put({ type: ASSIGNDISTRIBUTOREXCELFAILURE, payload: e });
    console.error('❌ AssignDistributorExcel Saga - Failure action dispatched due to exception');
  }
}

export function* GetAgentsDistributorWiseAsync({ params }) {
  try {
    const response = yield call(API.GetAgentsDistributorWise, params);
    yield put({
      type: GET_AGENTS_DISTRIBUTOR_WISE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: GET_AGENTS_DISTRIBUTOR_WISE_FAILURE, payload: e });
  }
}

export default function* rootSaga() {
  yield takeLatest(LOGINREQUEST, GetLoginAsync);
  yield takeLatest(GETINVENTORYREQUEST, GetInventoryAsync);
  yield takeLatest(GETREPORTREQUEST, GetReportAsync);
  yield takeLatest(GETFASTAGREQUEST, GetFastagAsync);
  yield takeLatest(GETAGENTSREQUEST, GetAgentsAsync);
  yield takeLatest(GETAGENTSNAMESREQUEST, GetAgentsNamesAsync);
  yield takeLatest(GETINVENTORYDISTRIBUTORREQUEST, GetInventoryDistributorAsync);
  yield takeLatest(GETDISTRIBUTORREQUEST, GetDistributorAsync);
  yield takeLatest(GETDISTRIBUTORNAMESREQUEST, GetDistributorNamesAsync);
  yield takeLatest(GETINVENTORYAGENTREQUEST, GetInventoryAgentAsync);
  yield takeLatest(GETSTATEREQUEST, GetStateAsync);
  yield takeLatest(GETCITYREQUEST, GetCityAsync);
  yield takeLatest(SENDOTPREQUEST, SendOtpAsync);
  yield takeLatest(CHANGEPASSWORDREQUEST, ChangePasswordAsync);
  yield takeLatest(EDITDISTRIBUTORREQUEST, EditDistributorAsync);
  yield takeLatest(GETMASTERFASTAGREQUEST, GetMasterFastagAsync);
  yield takeLatest(GETALLAGENTSNAMESREQUEST, GetAllAgentsNamesAsync);
  yield takeLatest(GETINVENTORYSUMMARYREQUEST, GetInventorySummaryAsync);
  yield takeLatest(CREATEDISTRIBUTORBULKREQUEST, CreateDistributorBulkAsync);
  yield takeLatest(CREATEAGENTBULKREQUEST, CreateAgentBulkAsync);
  yield takeLatest(GETDISTRIBUTORSUMMARYREQUEST, GetDistributorSummaryAsync);
  yield takeLatest(GETDISTRIBUTORAGENTSUMMARYREQUEST, GetDistributorAgentSummaryAsync);
  yield takeLatest(GETAGENTSUMMARYREQUEST, GetAgentSummaryAsync);
  yield takeLatest(GETDISTRIBUTORREQUESTREQUEST, GetDistributorRequestAsync);
  yield takeLatest(ASSIGNAGENTEXCELREQUEST, AssignAgentExcelAsync);
  yield takeLatest(GETALLFASTAGAGENTREQUESTREQUEST, GetAllFastagAgentRequestAsync);
  yield takeLatest(GETAGENTFASTAGREQUEST, GetAgentFastagAsync);
  yield takeLatest(UPDATEAGENTREQUESTSTATUSREQUEST, UpdateAgentRequestStatusAsync);
  yield takeLatest(DENIEDREQUESTSTATUSREQUEST, DeniedRequestAsync);
  yield takeLatest(ASSIGNDISTRIBUTOREXCELREQUEST, AssignDistributorExcelAsync);
  yield takeLatest(GET_AGENTS_DISTRIBUTOR_WISE_REQUEST, GetAgentsDistributorWiseAsync);
}
